import React from 'react';
import styles from '../../../Tab.module.scss';
import { useRouteLoaderData } from 'react-router-dom';
import { ICustomer } from '../../../../model';
import { BillingSection } from '../../../../components/customer/Billing/Metrics/BillingSection';
import { useFormOutletContext } from './CustomerInfo';

const CustomerBillingInvoicesTab = () => {
  const customer = useRouteLoaderData('customer-info') as ICustomer;
  const { hasBillingAccess } = useFormOutletContext();


  return (
    <div className={styles.detailsLayout}>
      <div className={styles.contentWrapper}>
        <BillingSection customer={customer} hasBillingAccess={hasBillingAccess}></BillingSection>
      </div>
    </div>
  );
};

export default CustomerBillingInvoicesTab;
